<template>
   <div>
    <b-modal :id="modalId" size="md" centered scrollable  :title="TitleWindow" @ok="this.emitEventOK" @cancel="this.emitEventCancel" @hide="resetModal" :cancel-title="$t('Shared.BtnCancel')"> 
      <b-row style="width:450px;">      
        <b-col lg="8" md="8" sm="12">
          <MdLookup
                v-bind:Label="$t('Shared.ProgramCode')"
                v-bind:ModelCode="ProgramCode"
                v-bind:ModelDescription="dProgram"
                v-bind:RefCode="'Program'"
                v-bind:Api="'programs'"
                v-bind:FieldCode="'code'"
                v-bind:FieldDescription="'name'"                              
                :SearchTitle="$t('Shared.ProgramCode')"
                :GetValues="onCodeConditionOk"
                :InvalidFeedback="$t('transfer.InvalidProgramCode')"
                :SearchFieldCode="'Code'" 
                 v-bind:Fields="BaseFields"/>
        </b-col>       
      </b-row>
    </b-modal>
   </div>
</template>

<script>
export default {
  name: 'ModalEmployeeProgram',
   props: {
     ModalId: String,
     TitleWindow:String
   },
   data(){
       return { 
          modalId:this.ModalId, 
          ProgramCode:"",
          dProgram:"",
          BaseFields:[
            { key: 'name', sortable: true, label: this.$t('Shared.FirstName') },
            { key: 'code', sortable: true, label: this.$t('Shared.Code')},
            { key: 'inPatient', sortable: true, label: this.$t('Shared.Inpatient')},
            { key: 'isInPatient', sortable: true, label: this.$t('Shared.IsInPatient')}
          ]
       }
   },

   methods:{

    emitEventOK(){
       // EventBus.$emit('getCodeConditionOK', {buildingCode:this.BuildingCode,buildingName:this.dBuilding});
       this.$emit('getCodeConditionOK', {programCode:this.ProgramCode,programName:this.dProgram});
    },
  
    emitEventCancel(){

    },

    onCodeConditionOk(result){
        var type = result.FieldName;       
             switch (type) {
                case "Program": 
                  this.ProgramCode = result.code;                    
                  this.dProgram = result.description;                    
                  break;
             }
    },

    resetModal(){

    },

   },

   mounted(){
 
      this.$root.$on('bv::modal::show', () => {     
        this.$nextTick(() => {
          setTimeout(500);
        });
      });
   }
   
};
</script>